import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SharedModule } from '$shared/shared.module';
import { SharedBatchModule } from '../../shared-batch';
import { AddressesRoutingModule } from './addresses-routing.module';
import { AddressesComponent } from './addresses.component';
import { FiltersComponent } from './components/filters/filters.component';
import { RecipientItemComponent } from './components/recipient-item/recipient-item.component';
import { IndexComponent } from './pages/index/index.component';
import { ContactBookConfigurationService, RecipientService } from './services';

@NgModule({
  declarations: [
    AddressesComponent,
    IndexComponent,
    RecipientItemComponent,
    FiltersComponent,
  ],
  imports: [
    CommonModule,
    AddressesRoutingModule,
    SharedBatchModule,
    SharedModule,
  ],
  exports: [RecipientItemComponent],
  providers: [RecipientService, ContactBookConfigurationService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AddressesModule {}
